import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { PenTool, Sparkles, Lock } from "lucide-react";

const AIWriter = () => {
  return (
    <div className="space-y-6 max-w-4xl mx-auto animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-heading font-bold text-slate-900">
            AI Writer Generator
          </h1>
          <p className="text-slate-600 mt-1">
            Generate professional press release drafts with AI assistance
          </p>
        </div>
        <Badge className="bg-amber-100 text-amber-700 border-amber-200">
          Coming Soon
        </Badge>
      </div>

      <Card className="border-2 border-dashed border-slate-300">
        <CardContent className="p-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-slate-100 mb-6">
            <PenTool className="h-10 w-10 text-slate-400" />
          </div>
          <h2 className="text-xl font-heading font-semibold text-slate-900 mb-3">
            AI-Powered Press Release Generator
          </h2>
          <p className="text-slate-600 max-w-md mx-auto mb-6">
            Our AI writer will help you create compelling press releases in minutes.
            Enter your topic, company details, and let AI do the heavy lifting.
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
            <Lock className="h-4 w-4" />
            <span>This feature is currently under development</span>
          </div>
        </CardContent>
      </Card>

      {/* Feature Preview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base font-medium flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-amber-500" />
              Smart Headlines
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-slate-600">
              Generate multiple headline options optimized for engagement and SEO.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base font-medium flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-blue-500" />
              Industry Templates
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-slate-600">
              Pre-trained on thousands of successful press releases across industries.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base font-medium flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-emerald-500" />
              Tone Control
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-slate-600">
              Choose from professional, casual, or formal tones to match your brand.
            </p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Get Notified</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-slate-600 mb-4">
            Be the first to know when AI Writer is available. We'll send you an email when it launches.
          </p>
          <Button className="bg-red-600 hover:bg-red-700" disabled>
            Notify Me When Available
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AIWriter;
